import { render } from "./TrainerManagement.vue?vue&type=template&id=0d6a509e&scoped=true"
import script from "./TrainerManagement.vue?vue&type=script&lang=js"
export * from "./TrainerManagement.vue?vue&type=script&lang=js"

import "./TrainerManagement.vue?vue&type=style&index=0&id=0d6a509e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6a509e"]])

export default __exports__